import { useEffect, useState } from "react";
import axios from "axios";
import "@/App.css";
import "@/Mobile.css";
import "@/Print.css";
import { AUTH_KEY } from "./lib/apiClient";
import { LoginScreen } from "./components/app/LoginScreen";
import { Dashboard } from "./components/app/Dashboard";

function App() {
  const [auth, setAuth] = useState(() => {
    try {
      const stored = JSON.parse(localStorage.getItem(AUTH_KEY) || "null");
      if (stored?.token) axios.defaults.headers.common["Authorization"] = `Bearer ${stored.token}`;
      return stored;
    } catch (e) { return null; }
  });

  useEffect(() => {
    if (auth?.token) axios.defaults.headers.common["Authorization"] = `Bearer ${auth.token}`;
    else delete axios.defaults.headers.common["Authorization"];
  }, [auth]);

  useEffect(() => {
    const id = axios.interceptors.response.use(
      (res) => res,
      (err) => {
        if (err.response?.status === 401) { localStorage.removeItem(AUTH_KEY); setAuth(null); }
        return Promise.reject(err);
      }
    );
    return () => axios.interceptors.response.eject(id);
  }, []);

  const handleLogin = (data) => { localStorage.setItem(AUTH_KEY, JSON.stringify(data)); axios.defaults.headers.common["Authorization"] = `Bearer ${data.token}`; setAuth(data); };
  const handleLogout = () => { localStorage.removeItem(AUTH_KEY); delete axios.defaults.headers.common["Authorization"]; setAuth(null); };

  if (!auth) return <LoginScreen onLogin={handleLogin} />;
  return <Dashboard auth={auth} onLogout={handleLogout} />;
}

export default App;
